






















import { defineComponent, onMounted } from '@vue/composition-api';

const HowTo = defineComponent({
  setup() {
    onMounted(() => { window.scrollTo(0, 0); });
  },
});

export default HowTo;
